// extracted by mini-css-extract-plugin
module.exports = {"callWrapper":"clinical-portal-3__CallSection__callWrapper"};